import { useState } from 'react';
import '../../styles/Documentation.css';
import Accordeon from '../CustomElements/Accordeon';
import CustomButton from '../CustomElements/CustomButton';
import HeaderForObject from '../CustomElements/HeaderForObject';
import ContractReport from './ContractReport';
import UippsReport from './UippsReport';
import translations from '../../content/PagesContent/DocumentationPage/documentationPageTranslations.json';
import useTranslations from '../../customHook/useTranslations';

function Documentation() {
  // получение словаря для статических данных в зависимости от выбранного языка
  const t = useTranslations(translations);

  const [selectedReportType, setSelectedReportType] = useState('contract');

  function handleReportTypeChange(reportType) {
    setSelectedReportType(reportType);
  }

  return (
    <>
      <Accordeon header={t?.reportSection || 'ОТЧЕТНОСТЬ'} hideAbove={1650}>
        <CustomButton
          key={0}
          width={'100%'}
          color={selectedReportType === 'contract' ? 'var(--sadr-success)' : 'white'}
          border={selectedReportType === 'contract' ? '' : true}
          colorText={selectedReportType === 'contract' ? 'white' : 'var(--sadr-text-color)'}
          text={t?.contractReportButton || 'Отчет по договору'}
          margin="0.5rem 0.5rem"
          onClick={() => handleReportTypeChange('contract')}
        />
        <CustomButton
          key={1}
          width={'100%'}
          color={selectedReportType === 'uipps' ? 'var(--sadr-success)' : 'white'}
          border={selectedReportType === 'uipps' ? '' : true}
          colorText={selectedReportType === 'uipps' ? 'white' : 'var(--sadr-text-color)'}
          text={t?.uippsReportButton || 'Отчет по УИППС'}
          margin="0.5rem 0.5rem"
          onClick={() => handleReportTypeChange('uipps')}
        />
      </Accordeon>

      <div className="documentation_content">
        <HeaderForObject show={false} onFilterChange={() => {}} onFilterSubmit={() => {}} />

        {selectedReportType === 'contract' && <ContractReport t={t} />}
        {selectedReportType === 'uipps' && <UippsReport t={t} />}
      </div>
    </>
  );
}
export default Documentation;
